// extracted by mini-css-extract-plugin
module.exports = {"messagesGrid":"MessagesGrid_messages-grid__1FjhI","tokenCell":"MessagesGrid_token-cell__1A673","token":"MessagesGrid_token__s9r4F"};